import { FC } from 'react';

interface PlayVideoButtonProps {
	size?: number;
	className?: string;
	color?: string;
	onClick?: () => void;
}

export const PlayVideoButton: FC<PlayVideoButtonProps> = ({
	size = 64,
	className = '',
	color = 'white',
	onClick,
}) => (
	<button
		onClick={onClick}
		// Use the color prop to define the outline and icon color
		style={{
			color,
			width: size,
			height: size,
			padding: 0,
			background: 'none',
			border: 'none',
			cursor: 'pointer',
		}}
		aria-label="Play video"
		className={className}
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={{ transition: 'transform 0.2s', display: 'block' }}
			onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
			onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1.0)')}
		>
			<circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
			<polygon points="10 8 16 12 10 16 10 8" fill="currentColor" stroke="none" />
		</svg>
	</button>
);
